// extracted by mini-css-extract-plugin
export default {"wrapper_footer":"Footer_wrapper_footer__O3Q1o"};